import { Item } from 'shared-types';

type RemovableItem = Pick<Item, 'id' | 'dynamicPackage' | 'packageBasketItemId'>;

const packageIdOf = (item: RemovableItem) => {
  if (item.dynamicPackage === 'parent') return item.id;
  if (item.dynamicPackage === 'child') return item.packageBasketItemId;
  return null;
};

export const removeBasketItem = <T extends RemovableItem>(
  items: T[],
  itemId: string | number
): T[] => {
  const target = items.find((item) => String(item.id) === String(itemId));
  if (!target) return items;
  const packageId = packageIdOf(target);
  if (packageId != null) {
    return items.filter(
      (item) =>
        String(item.id) !== String(packageId) &&
        String(item.packageBasketItemId) !== String(packageId) &&
        String(item.id) !== String(itemId)
    );
  }
  return items.filter((item) => String(item.id) !== String(itemId));
};
